<template>
  <div class="view">
    <wellcome />
    <video-block />
    <device />
    <why />
  </div>
</template>

<script>

import Wellcome from "./elements/Wellcome.vue";
import VideoBlock from "./elements/Video.vue";
import Device from './elements/Device.vue';
import Why from './elements/Why.vue';

export default {
  name      : 'Landing',
  components: {
    Wellcome,
    VideoBlock,
    Device,
    Why
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/_variables.scss';

  .view {
    background-color: $teal;
    padding-top: 80px;
    overflow: auto;
  }

  @media only screen and (max-width: $break-lg){
    .view {
      padding-top: 64px;
    }
  }

  .landing-section {
    border-radius: 108px 108px 0px 0px;
    margin-top: -98px;
    padding-bottom: 198px;
  }

  @media only screen and (max-width: 576px){
    .landing-section {
      border-radius: 50px 50px 0px 0px;
    }
  }
</style>
<style>
  .route-landing header.main-header {
    box-shadow: none;
  }

  @media only screen and (min-width: 1200px){
    .route-landing .container {
        max-width: 1240px;
    }
  }

  @media only screen and (max-width: 576px){
    .route-landing .container {
        padding-right: 35px;
        padding-left: 35px;
    }

    .route-landing .main-header .container {
      padding-right: 15px;
      padding-left: 15px;
    }
  }

  @media only screen and (max-width: 350px){
    .route-landing .container {
        padding-right: 15px;
        padding-left: 15px;
    }
  }
</style>